/**
 * TrendMart Accessible Quick View Controller
 */
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('[data-quick-view-modal]');
  const content = document.querySelector('[data-quick-view-content]');
  const closeBtn = document.querySelector('[data-quick-view-close]');

  if (!modal || !content) return;

  const openModal = () => {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    TrendMart.utils.trapFocus(modal);
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  // Global delegate for quick view buttons
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-swatch-dot], .tm-swatch-dot')) return;

    const trigger = e.target.closest('[data-quick-view-trigger]');
    if (!trigger) return;

    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;

    const handle = trigger.getAttribute('data-quick-view-trigger');
    if (!handle) return;

    e.preventDefault();
    const preselectedVariantId = trigger.getAttribute('data-selected-variant-id');

    content.innerHTML = '<div style="padding:40px;text-align:center;"><p>Loading product details...</p></div>';
    openModal();

    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {
        renderQuickView(product, preselectedVariantId);
      })
      .catch(err => {
        content.innerHTML = '<div style="padding:30px;text-align:center;"><p>Unable to load product preview.</p></div>';
      });
  });

  const renderQuickView = (product, preselectedVariantId) => {
    let currentVariant = product.variants[0];
    if (preselectedVariantId) {
      const found = product.variants.find(v => String(v.id) === String(preselectedVariantId));
      if (found) currentVariant = found;
    }
    const imageSrc = (currentVariant.featured_image && currentVariant.featured_image.src) || product.featured_image || (product.images && product.images[0]) || '';
    const formattedPrice = TrendMart.utils.formatMoney(currentVariant.price, TrendMart.moneyFormat);
    const formattedCompare = currentVariant.compare_at_price ? TrendMart.utils.formatMoney(currentVariant.compare_at_price, TrendMart.moneyFormat) : '';

    let optionsHtml = '';
    if (!product.has_only_default_variant && product.options) {
      product.options.forEach((opt, optIndex) => {
        optionsHtml += `
          <div style="margin-bottom: 14px;">
            <div style="font-weight:700;font-size:0.88rem;margin-bottom:6px;">${opt.name}:</div>
            <div style="display:flex;gap:6px;flex-wrap:wrap;">
              ${opt.values.map((val) => {
                const isSelected = currentVariant.options && currentVariant.options[optIndex] === val;
                return `
                <button type="button" class="tm-pill-option ${isSelected ? 'is-selected' : ''}" data-qv-option-index="${optIndex}" data-qv-val="${val}">
                  ${val}
                </button>
              `;}).join('')}
            </div>
          </div>
        `;
      });
    }

    content.innerHTML = `
      <div class="tm-quickview-grid">
        <div style="border-radius:var(--radius-card);overflow:hidden;background:#F8FAFC;aspect-ratio:1/1;">
          <img src="${imageSrc}" alt="${product.title}" style="width:100%;height:100%;object-fit:cover;" data-qv-image>
        </div>
        <div>
          <div style="font-size:0.82rem;color:var(--color-primary);font-weight:700;text-transform:uppercase;margin-bottom:4px;">${product.vendor || ''}</div>
          <h2 style="font-size:1.5rem;font-weight:800;color:var(--color-text-heading);margin-bottom:8px;">${product.title}</h2>
          <div class="tm-price-box" style="margin-bottom:14px;">
            <span class="tm-price__current ${currentVariant.compare_at_price > currentVariant.price ? 'tm-price__current--sale' : ''}" data-qv-price>${formattedPrice}</span>
            ${formattedCompare ? `<s class="tm-price__compare" data-qv-compare>${formattedCompare}</s>` : ''}
          </div>
          <div style="font-size:0.88rem;color:var(--color-text-body);margin-bottom:18px;max-height:100px;overflow-y:auto;">
            ${product.description ? product.description.replace(/<[^>]*>?/gm, '').substring(0, 160) + '...' : ''}
          </div>
          ${optionsHtml}
          <form method="post" action="/cart/add" data-quick-add-form style="display:flex;gap:10px;margin-top:16px;">
            <input type="hidden" name="id" value="${currentVariant.id}" data-qv-variant-id>
            <input type="number" name="quantity" value="1" min="1" style="width:50px;padding:8px;border:1px solid var(--color-border);border-radius:var(--radius-btn);text-align:center;">
            <button type="submit" class="tm-btn tm-btn--primary" style="flex:1;" data-qv-submit>
              Add to Cart
            </button>
          </form>
          <div style="margin-top:14px;text-align:center;">
            <a href="${product.url}" style="font-size:0.85rem;color:var(--color-primary);font-weight:600;">View full product details &rarr;</a>
          </div>
        </div>
      </div>
    `;

    // Bind option click in quick view
    const qvPills = content.querySelectorAll('[data-qv-option-index]');
    const qvVariantInput = content.querySelector('[data-qv-variant-id]');
    const qvPriceEl = content.querySelector('[data-qv-price]');
    const qvCompareEl = content.querySelector('[data-qv-compare]');
    const qvSubmitBtn = content.querySelector('[data-qv-submit]');

    qvPills.forEach(pill => {
      pill.addEventListener('click', () => {
        const groupIndex = pill.getAttribute('data-qv-option-index');
        content.querySelectorAll(`[data-qv-option-index="${groupIndex}"]`).forEach(p => p.classList.remove('is-selected'));
        pill.classList.add('is-selected');

        // find variant matching all selected options
        const currentSelected = [];
        product.options.forEach((_, idx) => {
          const selectedPill = content.querySelector(`[data-qv-option-index="${idx}"].is-selected`);
          if (selectedPill) currentSelected.push(selectedPill.getAttribute('data-qv-val'));
        });

        const matched = product.variants.find(v => v.options.every((opt, i) => opt === currentSelected[i]));
        if (matched) {
          qvVariantInput.value = matched.id;
          qvPriceEl.textContent = TrendMart.utils.formatMoney(matched.price, TrendMart.moneyFormat);
          if (qvCompareEl && matched.compare_at_price) {
            qvCompareEl.textContent = TrendMart.utils.formatMoney(matched.compare_at_price, TrendMart.moneyFormat);
          }
          if (matched.available) {
            qvSubmitBtn.disabled = false;
            qvSubmitBtn.textContent = 'Add to Cart';
          } else {
            qvSubmitBtn.disabled = true;
            qvSubmitBtn.textContent = 'Sold Out';
          }
        }
      });
    });
  };
});
